// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact {
  padding: 8rem 0;
  background: #050505;
  position: relative;
}

.contact-inner {
  display: grid;
  grid-template-columns: 1fr 1.4fr;
  gap: 6rem;
  align-items: start;
}

.contact-info {
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.contact-icon {
  font-size: 1.2rem;
  color: #bf00ff;
}

.contact-label {
  display: block;
  font-size: 0.7rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.3);
  margin-bottom: 0.2rem;
}

.contact-value {
  font-size: 1rem;
  color: rgba(255,255,255,0.8);
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-size: 0.72rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.4);
}

.form-group input,
.form-group select,
.form-group textarea {
  background: #111;
  border: 1px solid rgba(255,255,255,0.08);
  color: #fff;
  padding: 0.9rem 1rem;
  font-size: 0.95rem;
  outline: none;
  transition: border-color 0.3s;
  font-family: inherit;
  border-radius: 0;
  -webkit-appearance: none;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: rgba(191,0,255,0.5);
}

.form-group select option {
  background: #111;
  color: #fff;
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

.submit-btn {
  align-self: flex-start;
  padding: 1rem 2.5rem;
  font-size: 0.9rem;
}

@media (max-width: 1024px) {
  .contact-inner { grid-template-columns: 1fr; gap: 3rem; }
}

@media (max-width: 600px) {
  .form-row { grid-template-columns: 1fr; }
  .contact { padding: 5rem 0; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Contact.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;;EAGE,gBAAgB;EAChB,wCAAwC;EACxC,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB,0BAA0B,EAAE,SAAS,EAAE;AAC1D;;AAEA;EACE,YAAY,0BAA0B,EAAE;EACxC,WAAW,eAAe,EAAE;AAC9B","sourcesContent":[".contact {\n  padding: 8rem 0;\n  background: #050505;\n  position: relative;\n}\n\n.contact-inner {\n  display: grid;\n  grid-template-columns: 1fr 1.4fr;\n  gap: 6rem;\n  align-items: start;\n}\n\n.contact-info {\n  margin-top: 3rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.contact-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.contact-icon {\n  font-size: 1.2rem;\n  color: #bf00ff;\n}\n\n.contact-label {\n  display: block;\n  font-size: 0.7rem;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: rgba(255,255,255,0.3);\n  margin-bottom: 0.2rem;\n}\n\n.contact-value {\n  font-size: 1rem;\n  color: rgba(255,255,255,0.8);\n}\n\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-group label {\n  font-size: 0.72rem;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: rgba(255,255,255,0.4);\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  background: #111;\n  border: 1px solid rgba(255,255,255,0.08);\n  color: #fff;\n  padding: 0.9rem 1rem;\n  font-size: 0.95rem;\n  outline: none;\n  transition: border-color 0.3s;\n  font-family: inherit;\n  border-radius: 0;\n  -webkit-appearance: none;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  border-color: rgba(191,0,255,0.5);\n}\n\n.form-group select option {\n  background: #111;\n  color: #fff;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.submit-btn {\n  align-self: flex-start;\n  padding: 1rem 2.5rem;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 1024px) {\n  .contact-inner { grid-template-columns: 1fr; gap: 3rem; }\n}\n\n@media (max-width: 600px) {\n  .form-row { grid-template-columns: 1fr; }\n  .contact { padding: 5rem 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
